import { evalMeta } from 'utils/grid/grid';
import actionTypes from './users.action-types';
import * as api from '../resources/users.api';

export const fetchUsersRequest = () => ({
  type: actionTypes.FETCH_USERS_REQUEST,
  isLoading: true,
});

export const fetchUsersFailure = () => ({
  type: actionTypes.FETCH_USERS_FAILURE,
  isLoading: false,
});

export const fetchUsersSuccess = ({ content, ...pagination }) => ({
  type: actionTypes.FETCH_USERS_SUCCESS,
  content,
  pagination: evalMeta(pagination),
  isLoading: false,
});

export const fetchUsers = (params) => async (dispatch, getStore) => {
  const { session } = getStore();
  const {
    lotteryRepId,
    id,
    retailer,
    locale,
  } = session;
  const config = {
    ...params,
    locale,
    userId: lotteryRepId ? null : id,
    currentRetailer: retailer.retailerId || null,
  };

  dispatch(fetchUsersRequest());

  try {
    const result = await api.fetchUsers(config);
    dispatch(fetchUsersSuccess(result));
  } catch (error) {
    dispatch(fetchUsersFailure(error));
    console.error('FETCH_USERS', error);
  }
};

export const downloadUsersReportRequest = () => ({
  type: actionTypes.DOWNLOAD_USERS_REPORT_REQUEST,
});

export const downloadUsersReportFailure = () => ({
  type: actionTypes.DOWNLOAD_USERS_REPORT_FAILURE,
});

export const downloadUsersReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_USERS_REPORT_SUCCESS,
});

export const downloadUsersReport = ({ extension, ...params }) => (dispatch, getState) => {
  const { session } = getState();
  const { lotteryRepId } = session;

  const config = {
    lotteryRepId,
    extension,
    ...params,
  };

  try {
    dispatch(downloadUsersReportRequest());
    dispatch(downloadUsersReportSuccess());
    return api.downloadUsersReport(config);
  } catch (error) {
    dispatch(downloadUsersReportFailure());
    console.error('DOWNLOAD_USERS_REPORT', error);
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/actions/users.actions.js